/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });


    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showProgressBar: function () {
    var progressBars = $('.ajax-cart__dynamic_line');

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (!error) {
          var countryIsCA = Shopify.customerPrivacy.getRegion().slice(0,2) == 'CA' && Shopify.country == 'CA';
           
        if(countryIsCA) {
            progressBars.removeClass('hide');
            $('.ajax-cart__shipping').show();

            var customSubtotalEl = document.querySelector('.ajax-cart__subtotal .money');
            if (customSubtotalEl) {
              var rawSubtotal = customSubtotalEl.getAttribute('data-custom-subtotal') || '';
              var subtotalCents = parseInt(rawSubtotal.replace(/[^0-9]/g, '')) || 0;
              if (subtotalCents === 0) {
                progressBars.filter('.active').addClass('hide');
                $('.ajax-cart__shipping').hide();
              }
            }
          }
        } else {
          console.warn('Failed to load consent-tracking-api', error);
        }
      },
     );
  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

        this.showProgressBar();

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

        this.showProgressBar();
      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {

          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          window.PXUTheme.jsAjaxCart.showDrawer();
          window.PXUTheme.jsAjaxCart.updateView();

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: XMLHttpRequest => {
          const response = eval('(' + XMLHttpRequest.responseText + ')');

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  handleGiftCards: function () {
    // Prevent multiple simultaneous gift card operations
    if (window.PXUTheme.jsAjaxCart.processingGiftCards) {
      return;
    }

    const cartList = document.querySelector('.jsAjaxCart .ajax-cart__list');
    if (!cartList) return;
  
    // Get gift card variant IDs and eligibility, ordered from highest to lowest tier
    const giftVariantIds = [
      {
        variantId: cartList.dataset.thirdGiftVariantId,
        eligible: cartList.dataset.thirdLevelEligible === 'true'
      },
      {
        variantId: cartList.dataset.secondGiftVariantId,
        eligible: cartList.dataset.secondLevelEligible === 'true'
      },
      {
        variantId: cartList.dataset.firstGiftVariantId,
        eligible: cartList.dataset.firstLevelEligible === 'true'
      }
    ].filter(gift => gift.variantId);

    // Get all cart items and find any gift cards in cart
    const cartItems = document.querySelectorAll('.jsAjaxCart [data-cart-item]');
    const giftCardsInCart = Array.from(cartItems)
      .map(item => {
        const itemKey = item.dataset.cartItem;
        const itemVariantId = item.dataset.cartItemVariant;

        const isGiftCard = giftVariantIds.find(gift => 
          gift.variantId === itemVariantId
        );
        
        return isGiftCard ? {
          key: itemKey,
          variantId: itemVariantId
        } : null;
      })
      .filter(item => item !== null);

    // Find highest eligible gift card variant
    const highestEligibleGift = giftVariantIds.find(gift => gift.eligible);

    // Determine required action
    let action = null;

    if (giftCardsInCart.length > 1) {
      // Multiple gift cards found - remove all except the highest tier one
      action = {
        type: 'cleanup',
        cardsToRemove: giftCardsInCart.filter(card => card.variantId !== highestEligibleGift?.variantId)
      };
    } else if (giftCardsInCart.length === 1) {
      const currentCard = giftCardsInCart[0];
      
      if (!highestEligibleGift) {
        // Not eligible for any gift card - remove current
        action = {
          type: 'remove',
          key: currentCard.key
        };
      } else if (currentCard.variantId !== highestEligibleGift.variantId) {
        // Eligible for a different tier - replace current
        action = {
          type: 'replace',
          key: currentCard.key,
          newGiftId: highestEligibleGift.variantId
        };
      }
      // If current card is already the highest eligible tier, do nothing
    } else if (highestEligibleGift) {
      // No gift card in cart but eligible for one
      action = {
        type: 'add',
        giftId: highestEligibleGift.variantId
      };
    }

    // Execute required action if any
    if (action) {
      let operations = [];
      
      if (action.type === 'cleanup') {
        // Remove all gift cards except the highest tier
        action.cardsToRemove.forEach(card => {
          operations.push({
            url: '/cart/change.js',
            data: {
              'id': String(card.key),
              'quantity': 0
            }
          });
        });
      } else if (action.type === 'remove' || action.type === 'replace') {
        operations.push({
          url: '/cart/change.js',
          data: {
            'id': String(action.key),
            'quantity': 0
          }
        });
      }
      
      if (action.type === 'add' || action.type === 'replace') {
        operations.push({
          url: '/cart/add.js',
          data: {
            'id': action.type === 'add' ? action.giftId : action.newGiftId,
            'quantity': 1,
            'properties': {
              '_auto_gift': 'true'
            }
          }
        });
      }

      // Execute operations sequentially
      if (operations.length > 0) {
        window.PXUTheme.jsAjaxCart.processingGiftCards = true;

        // Execute operations one by one
        operations.reduce((promise, operation) => {
          return promise.then(() => {
            console.warn('Executing operation:', operation);
            return fetch(operation.url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(operation.data)
            }).then(response => response.json());
          });
        }, Promise.resolve())
        .then((data) => {
          console.warn('All operations completed:', data);
          // Update the cart view without triggering gift card handling
          window.PXUTheme.jsAjaxCart.updateView(true);
          window.PXUTheme?.jsCart?.updateView(true);
        })
        .catch((err) => {
          console.error('Gift card operation error:', err);
        })
        .finally(() => {
          // Reset processing flag after a short delay to ensure view update is complete
          setTimeout(() => {
            window.PXUTheme.jsAjaxCart.processingGiftCards = false;
          }, 100);
        });
      }
    }
  },
  updateView: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      let itemList,
        cartDetails;

      if (options.item_count > 0) {
        itemList = $(html.content).find('.ajax-cart__list');
        cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

        this.handleGiftCards();

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }


      var progressBar = $('.ajax-cart__dynamic_line.active');
      if(progressBar.length) {
        
        // var haveExceptProd = itemList.data('haveExceptProd');
        // if(haveExceptProd) {
        // var countryIsCA = Shopify.customerPrivacy.getRegion().slice(0,2) == 'CA';
        // var countryIsCA = Shopify.customerPrivacy.getRegion().slice(0,2) == 'UA';
        
        // if(countryIsCA) {
        //   progressBar.removeClass('hide');
        //   $('.ajax-cart__shipping').show();
        //   return;
        // }

        this.showProgressBar();
        
        setTimeout(function() {
          let cartTotal = document.querySelector('.ajax-cart__subtotal .money').getAttribute('data-custom-subtotal');

          
          if(!cartTotal) cartTotal = 0;
          var maxAmmount = progressBar.find('.caption').data('maximumAmmount') * 100;
          if(maxAmmount) {
            cartTotal = parseInt(cartTotal.replace('$', '').replace(',', '').replace('.', ''));
            if(cartTotal === 0) {
              progressBar.addClass('hide');
              $('.ajax-cart__shipping').hide();
              return;
            }
            var percents = 100 * cartTotal / maxAmmount;
            if(percents > 100) percents = 100;
            if(percents == 100) {
              var text = progressBar.find('.caption').data('messageAfter').replace('[ammount]', Shopify.formatMoney(maxAmmount, Shopify.money_format));
              $('.ajax-cart__shipping').show();
            }
            else {
              var text = progressBar.find('.caption').data('messageBefore').replace('[ammount]', Shopify.formatMoney((maxAmmount - cartTotal), Shopify.money_format));
              $('.ajax-cart__shipping').hide();
            }
            progressBar.find('.caption p').html(text);
            progressBar.find('.line .filled-line').css('width', percents+'%');
          }
        }, 100);
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;